import { NetworkingService } from './networking.service';

export const SERVICES = [
  NetworkingService
];
